(function($, undefined) {
	
	'use strict';
	var cartCom;
	var isLoggedIn = false;
	var isMobile = false;
	var win = $(window);
	var winWidth;
	var winHeight;
	
	var header;
	var navItems;
	
	var toggleMenuBtn;
	var toggleSearchBtn;
	
	var toggleScroll = function () {
		if ($('html').hasClass('no-scroll')) {
			applyScroll();
		} else {
			removeScroll();
		}
	};
	
	var applyScroll = function () {
		$('html').removeClass('no-scroll');
		changeScrollDiff(0);
	};
	
	var removeScroll = function () {
		var w1 = win.width();
		$('html').addClass('no-scroll');
		var w2 = win.width();
		changeScrollDiff(w2 - w1);
	};
	
	var changeScrollDiff = function (diff) {
		$('.js-scroll-padding').css('padding-right', diff + 'px');
		$('.js-scroll-right').css('right', diff + 'px');
	};
	
	var onClickMenuToggle = function () {
		if (!!$('body').hasClass('menu-open')) {
			var transitionEnd = 'transitionend webkitTransitionEnd oTransitionEnd otransitionend';
			$('body').removeClass('menu-open');
			$(document).off('click', outsideClickMenu);
			
			header.one(transitionEnd, function(e) {
				applyScroll();
				$('.header__shop-window__cats, .header__shop-window').removeClass('open');
			});
		} else {
			openMenu();
			$(document).on('click', outsideClickMenu);
		}
	};
	
	var openMenu = function () {
		$('body').addClass('menu-open');
		removeScroll();
	};
	
	var outsideClickMenu = function (event) {
		if (!$(event.target).closest('.site-header').length) {
			closeMenu();
		}
	};
	
	var closeMenu = function () {
		if ($('body').hasClass('menu-open')) {
			$('body').removeClass('menu-open');
			applyScroll();
			$(document).off('click', outsideClickMenu);
		}
	};
	
	var toggleSearch = function () {
		$('.site-header').toggleClass('search-open');
		$('.header__search-bar [name=q]').focus();
	};
	
	var changeCats = function (e) {
		var t = $(this);
		var currId = t.attr('data-id');
		var currHref = t.attr('href');
		
		$('.header__shop-window__parent-cats_link').removeClass('selected');
		t.addClass('selected');
		$('.header__shop-window__cats_item').removeClass('show');
		$('.header__shop-window__cats_item[data-parent-id="'+currId+'"]').addClass('show');
		
		$('.header__shop-window__cats_item.all a').attr('href', currHref);
		
		if ($('.header__nav').css('position') === 'fixed' && e.type === 'click' && t.attr('data-id') !== undefined) {
			$('.header__shop-window__cats').addClass('open');
			
			return false;
		}
	};
	
	var mobileOpenMenu = function () {
		var t = $(this).closest('.header__shop-btn');
		if ($('.header__nav').css('position') === 'fixed') {
			$('.header__shop-window', t).addClass('open');
			
			return false;
		}
	};
	
	var mobileCloseMenu = function () {
		$('.header__shop-window').removeClass('open');
		return false;
	};
	
	var closeCats = function () {
		$('.header__shop-window__cats').removeClass('open');
		return false;
	};
	
	var toggleLang = function() {
		$(this).closest('.site-header-lang').toggleClass('open');
	};
	
	var init = function () {
		cartCom = Fw.modules.models().cart;
		winWidth = win.width();
		winHeight = win.height();
		$('body').removeClass('no-scroll');
		
		header = $('.site-header');
		navItems = $('.nav-item-link', header);
		
		toggleMenuBtn = $('.header__mobile-menu-toggle-btn', header);
		toggleSearchBtn = $('.header__search-btn, .header__search-bar__close-btn', header);
		
		if($('body').hasClass('is-logged-in')) {
			isLoggedIn = true;
		}
		
		toggleMenuBtn.on('click', onClickMenuToggle);
		navItems.on('click', closeMenu);
		toggleSearchBtn.on('click', toggleSearch);
		$('.header__shop-window__parent-cats_link:not(.all)').hover(changeCats);
		$('.header__shop-window__parent-cats_link:not(.all)').click(changeCats);
		$('.header__shop-btn > a').click(mobileOpenMenu);
		$('.header__shop-window_back-to-cats').click(closeCats);
		$('.header__shop-window_back-to-menu').click(mobileCloseMenu);
		$('.header__bg').click(closeMenu);
		$('.header__cart').click(cartCom.toggleCart);
		$('.cart__header_close-btn').click(cartCom.closeCart);
		$('.site-header-lang-curr').click(toggleLang);
	};
	
	
	$(init);
	
	Fw.modules.export('header', {
		toggleScroll: toggleScroll,
		applyScroll: applyScroll,
		removeScroll: removeScroll
	});
	
})(jQuery);
